export enum Projectstatus {
	Order = 1,
	Gereed = 2
}